import React from 'react'
import { useCookies } from 'react-cookie';
import {Navigate} from 'react-router-dom'
import { useToast } from "@chakra-ui/react";

function PrivateRoute({children}) {
    const [cookies] = useCookies(['email']);
    const toast = useToast();

    const email = cookies.email;
    console.log(email,"pemail")

    // keep privacy only loged in user can acces some page 
    if(!email){
        toast({
              title:"Please Login or Create Account First",
              description:"Login or create account using gmail and password",
              position: "top-right",
              isClosable: true,
              status: 'error'
            })
       return <Navigate to="/login"/>
    }

    return children

  return (
    <div></div>
  )
}

export default PrivateRoute